(ns ui.storrito-api.page
  "Landing page promoting the Storrito API."
  (:require [storrito.ui.core :as ui]
            [ui.app-frame :as app-frame]))

(defn card [{:keys [href title description target]}]
  [:a {:href href
       :target target
       :class ["block"
               "rounded-lg"
               "border"
               "border-gray-200"
               "bg-white"
               "p-6"
               "shadow-sm"
               "hover:shadow-md"
               "hover:border-storrito-400"
               "transition-all"
               "no-underline"]}
   [:h3 {:class ["text-lg"
                  "font-semibold"
                  "text-gray-900"]}
    title]
   [:p {:class ["mt-2"
                "text-sm"
                "text-gray-600"]}
    description]])

(defn panel []
  [:div
   [:h1 {:class ui/h1} "Storrito API"]
   [:p {:class ["mt-2"
                "text-gray-700"
                "max-w-2xl"]}
    "Automate your social media workflow with the Storrito API. "
    "Schedule Instagram story posts and integrate Storrito into your own tools \u2014 all programmatically."]
   [:div {:class ["mt-8"
                  "grid"
                  "gap-6"
                  "sm:grid-cols-2"
                  "max-w-3xl"]}
    (card {:href "/documentation/api/v1/"
           :target "_blank"
           :title "API Documentation"
           :description "Explore the full API reference with endpoints, parameters, and example requests."})
    (card {:href "/ui/api-credential/manage/"
           :title "Manage API Credentials"
           :description "Create and manage API keys to authenticate your API requests."})
    (card {:href "/ui/api-webhook/manage"
           :title "Manage Webhooks"
           :description "Receive instant status updates when Instagram Story posts and social posts are scheduled, published, canceled, or failed."})]])

(defn render [state]
  (app-frame/app-frame
    state
    (panel)))

(def page
  {:page-id :pages/storrito-api
   :route [["ui" "storrito-api"]]
   :render #'render})
